export class AuthError extends Error {
    public response: { message: string };
    public status: number;

    public constructor(message: string, status: number) {
        super(message);

        this.response = { message };
        this.status = status;
    }
}
